import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from "react";
import { Box } from "@gemini/core";
import { Carousel as GeminiCarousel } from "@gemini/ui";
import { FloorplanSurvey, ImageDescription, Indicator, } from "@/components/UI/Carousel/addons";
import { InteractionEnum } from "@/types";
import { useCustomerAction, useIsLandscape } from "@/hooks";
import { LastImagePlaceholder } from "@/components/UI/Carousel/addons/LastImagePlaceholder";
import { useI18n } from "@/contexts/i18n";
import { useShowAds } from "@/ads/hooks/useShowAds";
import { AdSlotIds } from "@/shared/types";
export const Carousel = ({ medias, onScreenPress, showControls, initialStepIndex = 0, testId, mediasType, }) => {
    var _a, _b;
    const mediasCount = medias.length;
    const isLandscape = useIsLandscape();
    const { isAllSlotsLoaded } = useShowAds();
    const [currentStep, setCurrentStep] = useState(initialStepIndex);
    const { t } = useI18n();
    const imageSliderTestId = `${testId}.ImageSlider`;
    const showIndicator = showControls && currentStep < mediasCount;
    const lastImageDescription = isAllSlotsLoaded([AdSlotIds.AD_CAROUSEL])
        ? t("gallery.image.ad.description")
        : null;
    const imageDescription = currentStep < mediasCount
        ? (_a = medias[currentStep]) === null || _a === void 0 ? void 0 : _a.description
        : lastImageDescription;
    const { customerActionExposeInteraction } = useCustomerAction();
    const trackSliderNavigation = useCallback((index) => {
        customerActionExposeInteraction([
            { key: "interaction", value: InteractionEnum.IMAGE_SLIDE },
            { key: "index", value: index },
        ]);
    }, [customerActionExposeInteraction]);
    useEffect(() => {
        // reset carousel to `initialStepIndex` when images have changed, usually switching between tabs
        setCurrentStep(initialStepIndex);
    }, [mediasCount, initialStepIndex]);
    const onChange = (item) => {
        setCurrentStep(item.currentStep);
        trackSliderNavigation(currentStep);
    };
    const carouselItems = [
        ...medias.map((media) => {
            var _a;
            return ({
                id: media.key,
                item: (_jsxs(Box, { as: "picture", display: "flex", alignItems: "center", justifyContent: "center", onClick: onScreenPress, testId: `${imageSliderTestId}.Image.${media.originIndex}`, id: `picture-${media.originIndex}`, children: [(_a = media === null || media === void 0 ? void 0 : media.sources) === null || _a === void 0 ? void 0 : _a.map(({ media, url, key }) => (_jsx(Box, { as: "source", srcSet: url, media: media }, key))), _jsx(Box, { as: "img", src: media.url, alt: media.alt, objectFit: "contain", width: "auto", height: "auto", maxHeight: isLandscape ? "100dvh" : "calc(100dvh - 64px)", maxWidth: "100%", loading: "lazy" })] }, media.key)),
            });
        }),
        ...(mediasType === "images"
            ? [
                {
                    id: "contact-image",
                    item: (_jsx(LastImagePlaceholder, { testId: testId }, "last-image-placeholder")),
                },
            ]
            : []),
    ];
    return (_jsx(Box, { display: "flex", alignItems: "center", justifyContent: "center", overflow: ["hidden", "clip"], maxHeight: isLandscape ? "100%" : "calc(100svh - 64px)", minWidth: "100%", position: "relative", height: "100%", testId: "aviv.CDP.Gallery.Fullscreen.ImageSlider", children: _jsxs(Box, { display: "flex", alignItems: "center", width: "100%", children: [showIndicator && (_jsx(Indicator, { current: currentStep, total: mediasCount, hasTopOffset: isLandscape })), _jsx(GeminiCarousel, { "data-testid": "carousel", onChange: onChange, initialStepIndex: initialStepIndex, items: carouselItems, arrowPosition: undefined, shouldClipContent: true }), showControls && _jsx(ImageDescription, { description: imageDescription }), showControls && mediasType === "floorplans" && (_jsx(FloorplanSurvey, { mediaID: (_b = medias[currentStep]) === null || _b === void 0 ? void 0 : _b.key }))] }) }));
};
